import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import {
    UisExclamationTriangle,
    UisExclamationCircle,
    UisCheckCircle,
    UisCommentDots
} from '@iconscout/react-unicons-solid';
import { HealthProblemType } from '@nexxt/common/types';
interface HealthIconProps {
    questionID: number | string;
    type: HealthProblemType;
    active: boolean;
    className: string;
    message?: string;
    iconSize?: string;
}

const HealthIcon: React.FC<HealthIconProps> = (props: HealthIconProps) => {
    const renderIcon = () => {
        switch (props.type) {
            case HealthProblemType.ERROR:
                return (
                    <UisExclamationCircle
                        color="#D24D57"
                        size={props.iconSize || '24'}
                    />
                );
            case HealthProblemType.WARNING:
                return (
                    <UisExclamationTriangle
                        color="#F7CA18"
                        size={props.iconSize || '24'}
                    />
                );
            case HealthProblemType.DRAFT:
                return (
                    <UisCommentDots
                        color="#979797"
                        size={props.iconSize || '24'}
                    />
                );
            case HealthProblemType.SUCCESS:
                return (
                    <UisCheckCircle
                        color="#349A71"
                        size={props.iconSize || '24'}
                    />
                );
        }
    };

    return props.active ? (
        <React.Fragment>
            <span
                className={props.className}
                data-tip="custom show"
                data-for={`health-icon--${props.questionID}`}
            >
                {renderIcon()}
            </span>
            {[HealthProblemType.ERROR, HealthProblemType.WARNING].includes(
                props.type
            ) && (
                <ReactTooltip
                    id={`health-icon--${props.questionID}`}
                    aria-haspopup="true"
                    effect="solid"
                    place="bottom"
                >
                    <span>
                        {props.message ||
                            'Please click the tab and find the error(s) / warning(s)'}
                    </span>
                </ReactTooltip>
            )}
        </React.Fragment>
    ) : null;
};

export default HealthIcon;
